import api from "app/lib/api";
import endpoints from "static/endpoints";

export const getRpmCliniiView = async () => {
  const { data } = await api.get(endpoints.rpm.clinii.fetchRpmCliniiView);
  return data;
};
